import {
  IMeta_CRMImport_Metadata,
  IMeta_CRMImport_HeadingName,
  IMeta_CRMImport_HeadingName_Optional,
  IMeta_CRMImport_HeadingName_Required,
  IMeta_CRMImport_HeadingName_MagicTags,

  IField_CRMImport_Status_Created,
  IField_CRMImport_Status_LoadRunning,
  IField_CRMImport_Status_LoadComplete,
  IField_CRMImport_Status_LoadError,
  IField_CRMImport_Status_ProcessRunning,
  IField_CRMImport_Status_ProcessComplete,
  IField_CRMImport_Status_ProcessError,
  IField_CRMImport_Status_ImportRunning,
  IField_CRMImport_Status_ImportComplete,
  IField_CRMImport_Status_ImportError,

  IField_CRMImport_Status_Loading,
  IField_CRMImport_Status_Complete,
  IField_CRMImport_Status_Error,
  IField_CRMImport_Status,

  IField_CRMEvent_Type,
  IField_CRMEvent_Type_Created,
  IField_CRMEvent_Type_Updated,
  IField_CRMEvent_Type_Deleted,
  IField_CRMEvent_Type_Note_Created,
  IField_CRMEvent_Type_Note_Updated,
  IField_CRMEvent_Type_Note_Deleted,
  IField_CRMEvent_Type_Custom,
  IField_CRMEvent_Type_Emailed,
  IField_CRMEvent_Type_Phoned,
  IField_CRMEvent_Type_Astonish_Sent,
  IField_CRMEvent_Type_Astonish_Delivered,
  IField_CRMEvent_Type_Astonish_BadAddress,
  IField_CRMEvent_Type_Astonish_Bounced,
  IField_CRMEvent_Type_Astonish_Opened,
  IField_CRMEvent_Type_Astonish_Clicked,
  IField_CRMEvent_Type_Astonish_Unsubscribed,
  IField_CRMEvent_Type_Nopress_Form,
  IField_CRMEvent_Type_Booking_Created_Admin,
  IField_CRMEvent_Type_Booking_Updated_Admin,
  IField_CRMEvent_Type_Booking_Deleted_Admin,
  IField_CRMEvent_Type_Booking_Created_Public,

  IField_CRMEntity_Type_Astonish_Email,

} from '../types/schema/crm'

import {
  IField_CRMContact_List_Subscription,
  IField_CRMContact_List_Subscription_Any,
  IField_CRMContact_List_Subscription_Subscribed,
  IField_CRMContact_List_Subscription_Unsubscribed,
  IField_CRMContact_List_BadAddress,
  IField_CRMContact_List_BadAddress_Any,
  IField_CRMContact_List_BadAddress_Valid,
  IField_CRMContact_List_BadAddress_Invalid,
} from '../types/crm'

import {
  IStatus,
} from '../types/utils'

import {
  STATUS_CREATED,
  STATUS_STARTED,
  STATUS_ERROR,
  STATUS_COMPLETE,
} from './system'

/*

  crm

*/

export const CRM_ENTITY_TYPE_ASTONISH_EMAIL: IField_CRMEntity_Type_Astonish_Email = 'astonish_email'

export const CRM_IMPORT_STATUS_CREATED: IField_CRMImport_Status_Created = 'created'
export const CRM_IMPORT_STATUS_LOAD_RUNNING: IField_CRMImport_Status_LoadRunning = 'load_running'
export const CRM_IMPORT_STATUS_LOAD_COMPLETE: IField_CRMImport_Status_LoadComplete = 'load_complete'
export const CRM_IMPORT_STATUS_LOAD_ERROR: IField_CRMImport_Status_LoadError = 'load_error'
export const CRM_IMPORT_STATUS_PROCESS_RUNNING: IField_CRMImport_Status_ProcessRunning = 'process_running'
export const CRM_IMPORT_STATUS_PROCESS_COMPLETE: IField_CRMImport_Status_ProcessComplete = 'process_complete'
export const CRM_IMPORT_STATUS_PROCESS_ERROR: IField_CRMImport_Status_ProcessError = 'process_error'
export const CRM_IMPORT_STATUS_IMPORT_RUNNING: IField_CRMImport_Status_ImportRunning = 'import_running'
export const CRM_IMPORT_STATUS_IMPORT_COMPLETE: IField_CRMImport_Status_ImportComplete = 'import_complete'
export const CRM_IMPORT_STATUS_IMPORT_ERROR: IField_CRMImport_Status_ImportError = 'import_error'

export const CRM_IMPORT_STATUS_TITLES: Record<IField_CRMImport_Status, string> = {
  [CRM_IMPORT_STATUS_CREATED]: 'created',
  [CRM_IMPORT_STATUS_LOAD_RUNNING]: 'uploading',
  [CRM_IMPORT_STATUS_LOAD_COMPLETE]: 'uploaded',
  [CRM_IMPORT_STATUS_LOAD_ERROR]: 'upload error',
  [CRM_IMPORT_STATUS_PROCESS_RUNNING]: 'processing',
  [CRM_IMPORT_STATUS_PROCESS_COMPLETE]: 'processed',
  [CRM_IMPORT_STATUS_PROCESS_ERROR]: 'processing error',
  [CRM_IMPORT_STATUS_IMPORT_RUNNING]: 'importing',
  [CRM_IMPORT_STATUS_IMPORT_COMPLETE]: 'imported',
  [CRM_IMPORT_STATUS_IMPORT_ERROR]: 'import error',
}

// a map of CRM status onto generic item status
export const CRM_IMPORT_STATUS_MAP: Record<IField_CRMImport_Status, IStatus> = {
  [CRM_IMPORT_STATUS_CREATED]: STATUS_CREATED,
  [CRM_IMPORT_STATUS_LOAD_RUNNING]: STATUS_STARTED,
  [CRM_IMPORT_STATUS_LOAD_COMPLETE]: STATUS_CREATED,
  [CRM_IMPORT_STATUS_LOAD_ERROR]: STATUS_ERROR,
  [CRM_IMPORT_STATUS_PROCESS_RUNNING]: STATUS_STARTED,
  [CRM_IMPORT_STATUS_PROCESS_COMPLETE]: STATUS_CREATED,
  [CRM_IMPORT_STATUS_PROCESS_ERROR]: STATUS_ERROR,
  [CRM_IMPORT_STATUS_IMPORT_RUNNING]: STATUS_STARTED,
  [CRM_IMPORT_STATUS_IMPORT_COMPLETE]: STATUS_COMPLETE,
  [CRM_IMPORT_STATUS_IMPORT_ERROR]: STATUS_ERROR,
}

export const CRM_IMPORT_PROGRESS_MAP: Record<IField_CRMImport_Status, number> = {
  [CRM_IMPORT_STATUS_CREATED]: 0,
  [CRM_IMPORT_STATUS_LOAD_RUNNING]: 0,
  [CRM_IMPORT_STATUS_LOAD_COMPLETE]: 1,
  [CRM_IMPORT_STATUS_LOAD_ERROR]: 0,
  [CRM_IMPORT_STATUS_PROCESS_RUNNING]: 1,
  [CRM_IMPORT_STATUS_PROCESS_COMPLETE]: 2,
  [CRM_IMPORT_STATUS_PROCESS_ERROR]: 1,
  [CRM_IMPORT_STATUS_IMPORT_RUNNING]: 2,
  [CRM_IMPORT_STATUS_IMPORT_COMPLETE]: 3,
  [CRM_IMPORT_STATUS_IMPORT_ERROR]: 2,
}

export const CRM_IMPORT_STATUS_LOADING: IField_CRMImport_Status_Loading[] = [
  CRM_IMPORT_STATUS_LOAD_RUNNING,
  CRM_IMPORT_STATUS_PROCESS_RUNNING,
  CRM_IMPORT_STATUS_IMPORT_RUNNING,
]

export const CRM_IMPORT_STATUS_COMPLETE: IField_CRMImport_Status_Complete[] = [
  CRM_IMPORT_STATUS_LOAD_COMPLETE,
  CRM_IMPORT_STATUS_PROCESS_COMPLETE,
  CRM_IMPORT_STATUS_IMPORT_COMPLETE,
]

export const CRM_IMPORT_STATUS_ERROR: IField_CRMImport_Status_Error[] = [
  CRM_IMPORT_STATUS_LOAD_ERROR,
  CRM_IMPORT_STATUS_PROCESS_ERROR,
  CRM_IMPORT_STATUS_IMPORT_ERROR,
]

export const CRM_IMPORT_META_DEFAULT: IMeta_CRMImport_Metadata = {
  rows: 0,
  imported: 0,
  updated: 0,
  valid: 0,
  duplicates: 0,
  existed: 0,
  errors: 0,
  example: {},
  headings: [],
  mappings: [],
  tags: [],
}

export const CRM_IMPORT_HEADING_NAMES_REQUIRED: IMeta_CRMImport_HeadingName_Required[] = [
  'email',
]

export const CRM_IMPORT_HEADING_NAMES_OPTIONAL: IMeta_CRMImport_HeadingName_Optional[] = [
  'firstname',
  'surname',
  'company',
  'phone_number',
  'address1',
  'address2',
  'city',
  'postcode',
  'country',
]

export const CRM_IMPORT_HEADING_NAME_MAGIC_TAGS: IMeta_CRMImport_HeadingName_MagicTags = 'magic_tags'

export const CRM_IMPORT_HEADING_NAMES: IMeta_CRMImport_HeadingName[] = 
  [
    CRM_IMPORT_HEADING_NAMES_REQUIRED,
    CRM_IMPORT_HEADING_NAMES_OPTIONAL,
    [CRM_IMPORT_HEADING_NAME_MAGIC_TAGS],
  ].reduce<IMeta_CRMImport_HeadingName[]>((all, arr) => {
    return all.concat(arr)
  }, [])

export const CRM_IMPORT_HEADING_NAME_TITLES: Record<IMeta_CRMImport_HeadingName, string> = {
  firstname: 'First Name',
  surname: 'Surname',
  company: 'Company',
  email: 'Email Address',
  phone_number: 'Phone Number',
  phone_number2: 'Secondary Phone Number',
  address1: 'Address Line 1',
  address2: 'Address Line 2',
  city: 'City',
  postcode: 'Postcode',
  country: 'Country',
  magic_tags: 'Magic Tags',
}

export const CRM_CONTACT_MAGIC_TAGS: IMeta_CRMImport_HeadingName[] = 
  [
    CRM_IMPORT_HEADING_NAMES_REQUIRED,
    CRM_IMPORT_HEADING_NAMES_OPTIONAL,
  ].reduce<IMeta_CRMImport_HeadingName[]>((all, arr) => {
    return all.concat(arr)
  }, [])

export const CRM_EVENT_TYPE_CREATED: IField_CRMEvent_Type_Created = 'created'
export const CRM_EVENT_TYPE_UPDATED: IField_CRMEvent_Type_Updated = 'updated'
export const CRM_EVENT_TYPE_DELETED: IField_CRMEvent_Type_Deleted = 'deleted'
export const CRM_EVENT_TYPE_NOTE_CREATED: IField_CRMEvent_Type_Note_Created = 'note_created'
export const CRM_EVENT_TYPE_NOTE_UPDATED: IField_CRMEvent_Type_Note_Updated = 'note_updated'
export const CRM_EVENT_TYPE_NOTE_DELETED: IField_CRMEvent_Type_Note_Deleted = 'note_deleted'
export const CRM_EVENT_TYPE_CUSTOM: IField_CRMEvent_Type_Custom = 'custom'
export const CRM_EVENT_TYPE_EMAILED: IField_CRMEvent_Type_Emailed = 'emailed'
export const CRM_EVENT_TYPE_PHONED: IField_CRMEvent_Type_Phoned = 'phoned'
export const CRM_EVENT_TYPE_ASTONISH_SENT: IField_CRMEvent_Type_Astonish_Sent = 'astonish_sent'
export const CRM_EVENT_TYPE_ASTONISH_DELIVERED: IField_CRMEvent_Type_Astonish_Delivered = 'astonish_delivered'
export const CRM_EVENT_TYPE_ASTONISH_BADADDRESS: IField_CRMEvent_Type_Astonish_BadAddress = 'astonish_badaddress'
export const CRM_EVENT_TYPE_ASTONISH_BOUNCED: IField_CRMEvent_Type_Astonish_Bounced = 'astonish_bounced'
export const CRM_EVENT_TYPE_ASTONISH_OPENED: IField_CRMEvent_Type_Astonish_Opened = 'astonish_opened'
export const CRM_EVENT_TYPE_ASTONISH_CLICKED: IField_CRMEvent_Type_Astonish_Clicked = 'astonish_clicked'
export const CRM_EVENT_TYPE_ASTONISH_UNSUBSCRIBED: IField_CRMEvent_Type_Astonish_Unsubscribed = 'astonish_unsubscribed'
export const CRM_EVENT_TYPE_NOPRESS_FORM: IField_CRMEvent_Type_Nopress_Form = 'nopress_form'
export const CRM_EVENT_TYPE_BOOKING_CREATED_ADMIN: IField_CRMEvent_Type_Booking_Created_Admin = 'booking_created_admin'
export const CRM_EVENT_TYPE_BOOKING_UPDATED_ADMIN: IField_CRMEvent_Type_Booking_Updated_Admin = 'booking_updated_admin'
export const CRM_EVENT_TYPE_BOOKING_DELETED_ADMIN: IField_CRMEvent_Type_Booking_Deleted_Admin = 'booking_deleted_admin'
export const CRM_EVENT_TYPE_BOOKING_CREATED_PUBLIC: IField_CRMEvent_Type_Booking_Created_Public = 'booking_created_public'

export const CRM_EVENT_TYPE = [
  CRM_EVENT_TYPE_CREATED,
  CRM_EVENT_TYPE_UPDATED,
  CRM_EVENT_TYPE_DELETED,
  CRM_EVENT_TYPE_NOTE_CREATED,
  CRM_EVENT_TYPE_NOTE_UPDATED,
  CRM_EVENT_TYPE_NOTE_DELETED,
  CRM_EVENT_TYPE_CUSTOM,
  CRM_EVENT_TYPE_EMAILED,
  CRM_EVENT_TYPE_PHONED,
  CRM_EVENT_TYPE_ASTONISH_SENT,
  CRM_EVENT_TYPE_ASTONISH_DELIVERED,
  CRM_EVENT_TYPE_ASTONISH_BADADDRESS,
  CRM_EVENT_TYPE_ASTONISH_BOUNCED,
  CRM_EVENT_TYPE_ASTONISH_OPENED,
  CRM_EVENT_TYPE_ASTONISH_CLICKED,
  CRM_EVENT_TYPE_ASTONISH_UNSUBSCRIBED,
  CRM_EVENT_TYPE_NOPRESS_FORM,
  CRM_EVENT_TYPE_BOOKING_CREATED_ADMIN,
  CRM_EVENT_TYPE_BOOKING_UPDATED_ADMIN,
  CRM_EVENT_TYPE_BOOKING_DELETED_ADMIN,
  CRM_EVENT_TYPE_BOOKING_CREATED_PUBLIC,
]

export const CRM_EVENT_TYPE_TITLES: Record<IField_CRMEvent_Type, string> = {
  [CRM_EVENT_TYPE_CREATED]: 'created',
  [CRM_EVENT_TYPE_UPDATED]: 'updated',
  [CRM_EVENT_TYPE_DELETED]: 'deleted',
  [CRM_EVENT_TYPE_NOTE_CREATED]: 'note created',
  [CRM_EVENT_TYPE_NOTE_UPDATED]: 'note updated',
  [CRM_EVENT_TYPE_NOTE_DELETED]: 'note deleted',
  [CRM_EVENT_TYPE_CUSTOM]: 'custom',
  [CRM_EVENT_TYPE_EMAILED]: 'emailed',
  [CRM_EVENT_TYPE_PHONED]: 'phoned',
  [CRM_EVENT_TYPE_ASTONISH_SENT]: 'email sent',
  [CRM_EVENT_TYPE_ASTONISH_DELIVERED]: 'email delivered',
  [CRM_EVENT_TYPE_ASTONISH_BADADDRESS]: 'email bad address',
  [CRM_EVENT_TYPE_ASTONISH_BOUNCED]: 'email bounced',
  [CRM_EVENT_TYPE_ASTONISH_OPENED]: 'email opened',
  [CRM_EVENT_TYPE_ASTONISH_CLICKED]: 'email clicked',
  [CRM_EVENT_TYPE_ASTONISH_UNSUBSCRIBED]: 'email sunsubscribed',
  [CRM_EVENT_TYPE_NOPRESS_FORM]: 'website form submission',
  [CRM_EVENT_TYPE_BOOKING_CREATED_ADMIN]: 'booking created (admin)',
  [CRM_EVENT_TYPE_BOOKING_UPDATED_ADMIN]: 'booking updated (admin)',
  [CRM_EVENT_TYPE_BOOKING_DELETED_ADMIN]: 'booking deleted (admin)',
  [CRM_EVENT_TYPE_BOOKING_CREATED_PUBLIC]: 'booking created (public)',
}

export const CRM_EVENT_TYPE_MANUAL = [
  CRM_EVENT_TYPE_CUSTOM,
  CRM_EVENT_TYPE_EMAILED,
  CRM_EVENT_TYPE_PHONED,
]

export const CRM_CONTACT_LIST_SUBSCRIPTION_ANY: IField_CRMContact_List_Subscription_Any = 'any'
export const CRM_CONTACT_LIST_SUBSCRIPTION_SUBSCRIBED: IField_CRMContact_List_Subscription_Subscribed = 'subscribed'
export const CRM_CONTACT_LIST_SUBSCRIPTION_UNSUBSCRIBED: IField_CRMContact_List_Subscription_Unsubscribed = 'unsubscribed'

export const CRM_CONTACT_LIST_BADADDRESS_ANY: IField_CRMContact_List_BadAddress_Any = 'any'
export const CRM_CONTACT_LIST_BADADDRESS_VALID: IField_CRMContact_List_BadAddress_Valid = 'valid'
export const CRM_CONTACT_LIST_BADADDRESS_INVALID: IField_CRMContact_List_BadAddress_Invalid = 'invalid'

export const CRM_CONTACT_LIST_SUBSCRIPTION_DEFAULT = CRM_CONTACT_LIST_SUBSCRIPTION_ANY
export const CRM_CONTACT_LIST_BADADDRESS_DEFAULT = CRM_CONTACT_LIST_BADADDRESS_ANY

export const CRM_CONTACT_LIST_SUBSCRIPTION: IField_CRMContact_List_Subscription[] = [
  CRM_CONTACT_LIST_SUBSCRIPTION_ANY,
  CRM_CONTACT_LIST_SUBSCRIPTION_SUBSCRIBED,
  CRM_CONTACT_LIST_SUBSCRIPTION_UNSUBSCRIBED,
]

export const CRM_CONTACT_LIST_BADADDRESS: IField_CRMContact_List_BadAddress[] = [
  CRM_CONTACT_LIST_BADADDRESS_ANY,
  CRM_CONTACT_LIST_BADADDRESS_VALID,
  CRM_CONTACT_LIST_BADADDRESS_INVALID,
]

export const CRM_CONTACT_LIST_SUBSCRIPTION_TITLES: Record<IField_CRMContact_List_Subscription, string> = {
  [CRM_CONTACT_LIST_SUBSCRIPTION_ANY]: 'Any',
  [CRM_CONTACT_LIST_SUBSCRIPTION_SUBSCRIBED]: 'Subscribed',
  [CRM_CONTACT_LIST_SUBSCRIPTION_UNSUBSCRIBED]: 'Unsubscribed',
}

export const CRM_CONTACT_LIST_BADADDRESS_TITLES: Record<IField_CRMContact_List_BadAddress, string> = {
  [CRM_CONTACT_LIST_SUBSCRIPTION_ANY]: 'Any',
  [CRM_CONTACT_LIST_BADADDRESS_VALID]: 'Valid Address',
  [CRM_CONTACT_LIST_BADADDRESS_INVALID]: 'Invalid Address',
}